"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userContactSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.userContactSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['firstName', 'lastName', 'preferredLanguageCode'],
    properties: {
        extensionPhoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 7 characters or null',
        },
        faxNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters or null',
        },
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 15,
            errorMessage: 'should have variable length up to 15 characters',
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 25,
            errorMessage: 'should have variable length up to 25 characters',
        },
        phoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters or null',
        },
        preferredLanguageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
    },
};
